/**
 * Input Schema of TipoRelatorio
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {TipoRelatorio} from '@/model/resource/TipoRelatorio'
import {FormatoArquivoRelatorioCollection} from '@/model/collection/FormatoArquivoRelatorioCollection'

/* TODO: review generated schema */
export class InputTipoRelatorioSchema extends Schema {
  collectionFormatoArquivoRelatorio = new FormatoArquivoRelatorioCollection().noPagination()

  readonly name = 'InputTipoRelatorio'

  readonly fieldSet: FieldSet<TipoRelatorio> = {
    formatoArquivoRelatorio: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionFormatoArquivoRelatorio.all(),
      },
    }),
    descricao: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 100,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
